import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import React from "react";

import { Btn, BtnType } from "@/mk2/components/Btn";
import { LoadError } from "@/mk2/components/errors/LoadError";
import { NotFoundError } from "@/mk2/components/errors/NotFoundError";
import { CTA_RETURN_BACK } from "@/mk/autogenerated/translations/Failure.2b9e7db6f137e684524de8231fdfbad7";

interface OwnProps {
    errorMessage: string;

    backButtonUrl: string;
    backButtonLabel?: string;

    onRetry(): void;
}

export class Failure extends React.Component<OwnProps> {
    public render() {
        const { errorMessage, backButtonUrl, backButtonLabel, onRetry } = this.props;
        if (errorMessage && ["NOT FOUND", "GONE"].includes(errorMessage.toUpperCase())) {
            return (
                <NotFoundError
                    button={
                        <Btn
                            type={BtnType.Blue}
                            label={backButtonLabel || CTA_RETURN_BACK}
                            icon={faArrowLeft}
                            link={backButtonUrl}
                        />
                    }
                />
            );
        } else {
            return <LoadError onRetry={onRetry} />;
        }
    }
}
